<template>
  <div class="wrapper">
    <swiper
      ref="swiperSlide"
      class="urology-handbook-swiper"
      :options="swiperOption"
    >
      <swiper-slide
        v-for="(item, index) in images"
        :key="index"
        class="swiper-slide"
      >
        <img :src="item" alt="" class="urology-handbook-swiper-img" />
      </swiper-slide>
    </swiper>
    <div class="swiper-button-prevone" />
    <div class="swiper-button-nextone" />
  </div>
</template>

<script>
import cyShare from '@cy/share';
import * as cyDetect from '@cy/detect';
import { isIos } from '@/utils';

export default {
  data() {
    return {
      swiperOption: {
        direction: 'vertical',
        navigation: {
          nextEl: '.swiper-button-nextone',
          prevEl: '.swiper-button-prevone',
        },
      },

      images: [
        'https://staff.chunyu.mobi/@/media/images/2024/05/31/0c75/95d4293bad32_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/4652/b888d0924faf_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/3681/65994909ecd1_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/3291/ef3500cd2752_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/6d2f/4629fdc912cf_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/5af3/87cf7963a126_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/a742/b44c7cf7ec01_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/394f/d27cd4595e93_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/292d/d769e671bf3c_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/ba51/cd3c7b5f458b_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/5e08/367215cc2a7b_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/9df6/5de01b1c83b9_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/d8e2/aea54f8f2f04_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/2bf0/0aed971d95e7_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/c408/f9e8e85106b0_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/d35e/10f14506c8b2_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/c2cc/1c2a62c26bc4_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/312e/664645436758_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/af3a/dfe25201773a_w1125_h2155_.jpg',
        'https://staff.chunyu.mobi/@/media/images/2024/05/29/920f/11960c5bb23d_w1125_h2155_.jpg',
      ],
    };
  },
  mounted() {
    this.initShare();
    if (cyDetect.isFromCY()) {
      const ele = document.getElementsByClassName(
        'urology-handbook-swiper-img'
      )[0];
      ele.style.objectFit = 'cover';
    }
    if (cyDetect.isFromWechat() && isIos) {
      // const ele = document.getElementsByClassName('urology-handbook-swiper')[0];
      // ele.style.height = `${window.innerHeight - 83}px`;
    }
  },
  methods: {
    initShare() {
      const url = window.location.href;
      const shareInfo = {
        title: '2024年泌尿系统疾病预防科普手册',
        desc: '尿路不适“别硬扛” 及时用药享健康',
        userName: 'gh_681d3fd5683f',
        mini_id: 'gh_681d3fd5683f',
        link: url,
        path: `/pages/h5_webview/index?url=${encodeURIComponent(url)}`,
        mini_image:
          'https://resourced.chunyu.mobi/FwkAAAB6szDi76wW-cf6f2191-6b23-4906-9326-88877f4b72c4_w1024_h1024_.png',
        wx_scene_timeline_desc: '尿路不适“别硬扛” 及时用药享健康',
      };
      cyShare.app(shareInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.wrapper {
  width: 100%;
  height: 100%;
  .urology-handbook-swiper {
    height: 100vh;
    .swiper-container {
      height: 100%;
    }
    .swiper-wrapper {
      height: 100%;
    }
    .swiper-slide {
      height: 100%;
    }
    .swiper-pagination {
      bottom: rem(20);
    }
    .swiper-button-prev {
      left: rem(20);
    }

    background: rgb(249, 236, 227);
  }
  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    font-size: 18px;
    text-align: center;
    background: #fff;
  }
  .swiper-slide img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: rgb(249, 230, 213);
  }
  .swiper-button-prevone {
    position: fixed;
    bottom: rem(50);
    left: rem(20);
    z-index: 10;
    width: rem(120);
    height: rem(80);
  }
  .swiper-button-nextone {
    position: fixed;
    right: rem(20);
    bottom: rem(50);
    z-index: 10;
    width: rem(120);
    height: rem(80);
  }
}
</style>
